import { IWidget, IWidgetDefinition } from '../../common/core';
import { TreeFacetData, TreeFacetWidgetDefinition } from '../treefacet.widget/treefacet';
import { IFuseTreeFacetSettings } from './settings';
import { ITreeFacetState, TreeItem } from '../treefacet.widget/settings';
import { SortOption } from '../checkwidget/checkfacetdata';

const template = require('./fuse-treefacet.html');
const styles = require('./fuse-treefacet.scss').toString();

class FuseTreeFacetData extends TreeFacetData {
  constructor(public widget: IWidget<TreeFacetData, IFuseTreeFacetSettings, ITreeFacetState>) {
    super(widget);
  }
  fieldWithSort(path = '') {
    if (this.widget.settings.retrieveAll) {
      if (this.field && this.field.indexOf('@max_values:') == -1) {
        return `${this.field}@max_values:${Math.max(this.widget.settings.moreMaxFacets || 20, this.widget.settings.maxFacets || 100)}${this.sortQuery}`;
      } else {
        return `${this.field}${this.sortQuery}`;
      }
    } else {
      return super.fieldWithSort(path);
    }
  }
  setTerms(terms: TreeItem[]) {
    if (this.widget.settings.retrieveAll) {
      var termsMap = {};
      var results = [];
      terms.forEach(t => {
        var keyParts = t.term.split('\\').slice(1).filter(x => x);

        var parent;
        var path;
        keyParts.forEach(kp => {

          var fullKey = path ? `${path}\\${kp}` : kp;
          parent = termsMap[path];

          if (!termsMap[fullKey]) {
            termsMap[fullKey] = {
              term: kp,
              count: 0,
              more: false,
              children: []
            }
            if (parent) {
              parent.children.push(termsMap[fullKey]);
              parent.more = true;
            } else {
              results.push(termsMap[fullKey]);
            }
          }

          path = fullKey;
        });

        termsMap[path].count += t.count;

      });

      var sortItems = (items) => {

        var sort = this.widget.settings.sort || SortOption.countDesc;
        if (sort == SortOption.countAsc || sort == SortOption.countDesc) {
          items.sort((a, b) => {
            var ac = a.count;
            var bc = b.count;
            return sort == SortOption.countAsc ?
              (ac > bc ? 1 : -1) :
              (ac > bc ? -1 : 1);
          });
        }

        items.forEach(item => {
          if (item.children) {
            sortItems(item.children);
          }
        });
      };
      sortItems(results);

      if (this.widget.settings.adjustFacets) {
        results = this.widget.settings.adjustFacets(this.widget, results, null, null, null);
      }
      this.terms = results;

    } else {
      super.setTerms(terms);

      if (this.widget.service.g['showAllFacets'] && this.widget.service['_defaultFilters']) {
        this.widget.service['_defaultFilters'].then(resp => {
          var facets = resp.facets || {};
          var facet = facets[this.fieldWithSort("")] || {};
          var allTerms = JSON.parse(JSON.stringify(facet.terms || []));

          var tMap = {};
          terms.forEach(t => {
            tMap[t.term] = t;
          });

          allTerms.forEach(t => {
            t['id'] = `fuse-f-${this.name || this.widget.id}_${t.term}`;
            if (tMap[t.term]) {
              t.count = tMap[t.term].count;
              t._count = tMap[t.term]._count;
            } else {
              t.count = 0;
              t._count = 0;
            }
          });

          super.setTerms(allTerms);
        });
      }
    }
  }

  setTotals(term) {
    if (this.widget.settings.retrieveAll) {
      if (this.terms) {
        // set total count for top level items
        // NOTE: but this will not work for arrays
        this.totalCount = this.terms.reduce((res, t) => {
          if (t.count) {
            res += t.count;
          }
          return res;
        }, 0);
      }
    } else {
      super.setTotals(term);
    }
  }
};

export const FuseTreeFacetWidgetDefinition: IWidgetDefinition<FuseTreeFacetData, IFuseTreeFacetSettings, ITreeFacetState> = {
  ...TreeFacetWidgetDefinition,
  init(w) {
    w.data = new FuseTreeFacetData(w);

    if (w.service.g['showAllFacets']) {
      if (!w.service['_filterFields']) {
        w.service['_filterFields'] = [];
      }
      w.service['_filterFields'].push(w.d.fieldWithSort(""));
    }
  },
  template: template,
  styles: styles,
};

export { FuseTreeFacetData, TreeFacetWidgetDefinition };